import EditSimSkills from "./EditSimSkills"
export default EditSimSkills